export enum ProductItemInterval {
	// None = "none",

	// Reset interval
	Minute = "minute",
	Hour = "hour",
	Day = "day",
	Week = "week",

	// Billing interval
	Month = "month",
	Quarter = "quarter",
	SemiAnnual = "semi_annual",
	Year = "year",
}
